import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `RequestsControllerStateProvider` not mounted on RN.
export default function useRequestsControllerState(): any {
  const { state } = useController('RequestsController' as any)
  return state as any
}
